import { supabase } from './supabase';

/**
 * Enregistre une connexion utilisateur dans user_login_history
 * Non-bloquant : les erreurs sont loggées mais ne doivent pas empêcher le login
 */
export async function recordUserLogin(userId: string | number, username?: string): Promise<void> {
  try {
    const { data, error } = await supabase.rpc('record_user_login', {
      p_user_id: String(userId),
      p_username: username || null,
    });

    if (error) {
      console.warn('Failed to record user login:', error);
      return;
    }

    console.debug('User login recorded:', { userId, username });
  } catch (err) {
    console.warn('Error recording user login:', err);
  }
}

/**
 * Récupère les statistiques de connexion pour une période donnée
 */
export async function getLoginStatistics(days: number = 30) {
  try {
    const { data, error } = await supabase.rpc('get_login_statistics', {
      p_days: days,
    });

    if (error) throw error;
    return data?.[0] || null;
  } catch (err) {
    console.error('Failed to fetch login statistics:', err);
    return null;
  }
}

/**
 * Récupère les statistiques de connexion par jour
 */
export async function getLoginDailyStats(days: number = 30) {
  try {
    const { data, error } = await supabase.rpc('get_login_daily_stats', {
      p_days: days,
    });

    if (error) throw error;
    return data || [];
  } catch (err) {
    console.error('Failed to fetch daily login stats:', err);
    return [];
  }
}

/**
 * Récupère les top utilisateurs par nombre de connexions
 */
export async function getTopUsersByLogin(days: number = 30, limit: number = 10) {
  try {
    const { data, error } = await supabase.rpc('get_top_users_by_login', {
      p_days: days,
      p_limit: limit,
    });

    if (error) throw error;
    return data || [];
  } catch (err) {
    console.error('Failed to fetch top users by login:', err);
    return [];
  }
}
